import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BannerComponent } from '@/design-system/molecules/banner/banner.component';
import { ToastStore } from '@/features/toast-store.service';

@Component({
  selector: 'app-toast-layer',
  imports: [BannerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toast-layer.component.html',
  styleUrl: './toast-layer.component.scss',
})
export class ToastLayerComponent {
  private readonly toastStore = inject(ToastStore);

  protected readonly toasts = this.toastStore.toasts;

  protected dismiss(id: string): void {
    this.toastStore.startDismiss(id);
  }
}
